// extracted by mini-css-extract-plugin
module.exports = {"react-sweet-progress-circle":"react-sweet-progress-circle_1l1uU6"};